import { createContext } from 'react';

export const OfflineValuesContext = createContext({});

export default OfflineValuesContext;
